"use strict";

var Button = require("app/shared/components/Button/button");
var ExpandBox = require("app/shared/components/ExpandBox/expand-box");
var BooleanInput = require("app/shared/components/BooleanInput/boolean-input");
var DateRangePicker = require("app/shared/components/DateRangePicker/date-range-picker");
var FunnelSelectFilter = require("app/shared/components/FunnelSelectFilter/funnel-select-filter");
var Tooltip = require("app/shared/components/Tooltip/tooltip");
var cx = require("classnames");
var util = require("app/util/util");
var moment = require("moment");
var date = require("app/util/formatter/date");
var SummaryAPI = require("app/util/api/summary");
var SignalActions = require("app/shared/actions/signal-actions");

var CURRENT_MONTH_INDEX = 0;
var PREVIOUS_MONTH_INDEX = 1;
var PREVIOUS_THREE_MONTHS_INDEX = 2;
var CHOOSE_PERIOD_INDEX = 3;
var DATE_FORMAT = "YYYY-MM-DD";

var MonthlySummaryBox = React.createClass({
  propTypes: {
    expanded: React.PropTypes.bool,
    isPlanFree: React.PropTypes.bool.isRequired
  },

  getDefaultProps: function() {
    return {
      expanded: true
    };
  },

  getInitialState: function() {
    return {
      expanded: this.props.expanded,
      selectedInputIndex: null,
      inputList: [
        { text: "Desse mês", checked: false },
        { text: "1 mês atrás", checked: false },
        { text: "Últimos 3 meses", checked: false },
        { text: "Definir período", checked: false }
      ],
      selectedBeginDate: moment().startOf("month").format(DATE_FORMAT),
      selectedEndDate: moment().format(DATE_FORMAT),
      beginDateComparison: "",
      endDateComparison: "",
      selectedFunnel: this.props.funnel
    };
  },

  handleClickTitle: function() {
    this.setState({
      expanded: !this.state.expanded
    });
  },

  handleDateRangePickerSelection: function(dateText, event) {
    var selectedDate = date.formatDateFromJQueryDateUI(event);
    var comparisonDates = "";

    if (event.id == "beginDate") {
      comparisonDates = date.getRelativeComparisonRange(selectedDate, this.state.selectedEndDate);
      this.setState({
        selectedBeginDate: selectedDate,
        beginDateComparison: comparisonDates.beginDate,
        endDateComparison: comparisonDates.endDate
      });
    } else if (event.id == "endDate") {
      comparisonDates = date.getRelativeComparisonRange(this.state.selectedBeginDate, selectedDate);
      this.setState({
        selectedEndDate: selectedDate,
        beginDateComparison: comparisonDates.beginDate,
        endDateComparison: comparisonDates.endDate
      });
    }
  },

  handleFunnelSelection: function (_, funnelId) {
    this.setState({ selectedFunnel: funnelId });
  },

  handleRadioInputClick: function(inputIndex) {
    var newInputList = util.deepClone(this.state.inputList);

    newInputList.reduce(function(previous, current, index) {
      if (index == inputIndex) {
        current.checked = true;
      } else {
        current.checked = false;
      }
    }, null);

    var dateRange = this.buildDateRangeFromIndex(inputIndex);
    var comparisonDates = date.getRelativeComparisonRange(dateRange.beginDate, dateRange.endDate);

    this.setState({
      selectedInputIndex: inputIndex,
      inputList: newInputList,
      selectedBeginDate: dateRange.beginDate,
      selectedEndDate: dateRange.endDate,
      beginDateComparison: comparisonDates.beginDate,
      endDateComparison: comparisonDates.endDate
    });
  },

  buildDateRangeFromIndex: function(index) {
    var beginDate = "";
    var endDate = "";

    switch(index) {
      case CURRENT_MONTH_INDEX:
      case CHOOSE_PERIOD_INDEX:
        beginDate = moment().startOf("month").format(DATE_FORMAT);
        endDate = moment().format(DATE_FORMAT);
        break;
      case PREVIOUS_MONTH_INDEX:
        beginDate = moment().subtract(1, 'month').startOf("month").format(DATE_FORMAT);
        endDate = moment().subtract(1, 'month').endOf("month").format(DATE_FORMAT);
        break;
      case PREVIOUS_THREE_MONTHS_INDEX:
        beginDate = moment().subtract(3, 'month').startOf("month").format(DATE_FORMAT);
        endDate = moment().subtract(1, 'month').endOf("month").format(DATE_FORMAT);
        break;
    }

    return {
      beginDate: beginDate,
      endDate: endDate
    };
  },

  getBoxHeight: function() {
    var boxHeight = "";

    switch(this.state.selectedInputIndex) {
      case CHOOSE_PERIOD_INDEX:
        boxHeight = "365px";
        break;
      case CURRENT_MONTH_INDEX:
      case PREVIOUS_MONTH_INDEX:
        boxHeight = "318px";
        break;
      case PREVIOUS_THREE_MONTHS_INDEX:
        boxHeight = "330";
        break;
      default:
        boxHeight = "300px";
    }

    return boxHeight;
  },

  getStyles: function() {
    var isChoosePeriodSelected = this.state.selectedInputIndex == CHOOSE_PERIOD_INDEX;

    return {
      boxHeight: this.getBoxHeight(),
      choosePeriodClass: cx("monthlySummaryBox-choosePeriod", {
        "monthlySummaryBox-choosePeriod--selected": isChoosePeriodSelected,
        "monthlySummaryBox-choosePeriod--blur": !isChoosePeriodSelected,
      }),
      listItensClass: cx("w-100pct mt-10", {
        "d-ib": this.state.expanded,
        "d-n": !this.state.expanded
      })
    }
  },

  requestMonthlySummary: function() {
    var params = {
      begin_date: this.state.selectedBeginDate,
      end_date: this.state.selectedEndDate,
      begin_date_compare: this.state.beginDateComparison,
      end_date_compare: this.state.endDateComparison,
      funnel_id: this.state.selectedFunnel
    };

    SummaryAPI.post(params,
      (body) => {
        this.setState({
          expanded: false
        });
        this.showSignal("O Sumário mensal foi enviado para o email " + window.loggedUserEmail + ". Pode demorar alguns instantes, para o email chegar.", "success");
      },
      (error, response) => {
        this.showSignal("Não foi possível solicitar o sumário, tente novamente mais tarde.", "warning");
      }
    );
  },

  showSignal: function(message, type) {
    SignalActions.show({
      message: message,
      type: type,
      hideTimeout: 5000
    });
  },

  renderInputList: function() {
    return this.state.inputList.map(function (listItem, index) {
      var noteText = "";
      if (index == PREVIOUS_THREE_MONTHS_INDEX) {
        noteText = "Comparado com o mesmo período do ano anterior";
      }

      return (
        <InputListItem {...listItem}
          key={index}
          index={index}
          handleClick={this.handleRadioInputClick}
          beginDate={this.state.beginDateComparison}
          endDate={this.state.endDateComparison}
          noteText={noteText} />
      );
    }.bind(this))
  },

  render: function() {
    var styles = this.getStyles();
    var disableRequestButton =
      typeof this.state.selectedInputIndex != "number" || this.state.selectedFunnel == null;

    return (
      <ExpandBox title="Sumário mensal" onClick={this.handleClickTitle} expanded={this.state.expanded} boxHeight={styles.boxHeight}>
        <div className="c-666 ta-l fs-16">Escolha o funil</div>
        <FunnelSelectFilter
          className="mt-10"
          setFilter={this.handleFunnelSelection}
          filters={this.state}
          showDefaultOption={false}
        />

        <div className="c-666 ta-l fs-16 mt-15">Escolha o período</div>
        <div className={styles.listItensClass}>
          <ul className="c-666 mb-0">
            { this.renderInputList() }
          </ul>
          <div className={styles.choosePeriodClass}>
            <DateRangePicker beginDate={this.state.selectedBeginDate} endDate={this.state.selectedEndDate} handleSelection={this.handleDateRangePickerSelection}/>
          </div>
          <div className="mt-15 d-f jc-sb">
            <span>
              <Button type="default" href={{url: "/sistema/configuracoes/#fieldSummary", name: "_blank"}}>Configuração</Button>
            </span>
            <span className="ml-10">
              {
                this.props.isPlanFree
                ? <Tooltip top title="O Sumário mensal é uma funcionalidade dos Planos Pro. Para recebê-lo adquira um Plano Pro." >
                    <Button type="primary" disabled={true}>Solicitar</Button>
                  </Tooltip>
                : <Button type="primary" onClick={this.requestMonthlySummary} disabled={disableRequestButton}>Solicitar</Button>
              }

            </span>
          </div>
        </div>
      </ExpandBox>
    );
  }
});

const InputListItem = (props) => {
  var handleClick = function() {
    props.handleClick(props.index);
  };

  var noteClass = cx("monthlySummaryBox-listItem-note", {
    "monthlySummaryBox-listItem-note--opened": props.checked,
    "h-25": props.noteText && props.checked
  });

  var beginDate = moment(props.beginDate).format("DD/MM/YYYY");
  var endDate = moment(props.endDate).format("DD/MM/YYYY");

  return (
    <li className="ptb-5 c-pointer" onClick={handleClick}>
      <div className="f-l mr-5">
        <BooleanInput
          type="radioButton"
          checked={props.checked}
          border="thin"
          placement="left"
          color="doveGray">
        </BooleanInput>
      </div>
      {props.text}
      {
        props.noteText
        ? <div className={noteClass}>{props.noteText}</div>
        : <div className={noteClass}>Comparado com {beginDate} a {endDate}</div>
      }
    </li>
  );
};

module.exports = MonthlySummaryBox;



// WEBPACK FOOTER //
// ./app/screens/Report/MonthlySummaryBox/monthly-summary-box.jsx